var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 60,
    viewBox: "0 0 70 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.2756 22.9531C60.8921 22.2909 58.4293 21.8251 55.9038 21.566L51.2706 29.4976L46.6353 21.566C44.0993 21.823 41.6281 22.2888 39.2363 22.9572C39.0024 23.022 38.7726 23.0951 38.5491 23.1766C38.0812 23.3521 37.6947 23.6884 37.4482 24.1166L22.3182 50.3262H30.1119L38.9898 38.104V60L67.28 59.998L69.7074 32.2509C70.0708 28.0919 67.4409 24.1229 63.2756 22.9531Z",
    fill: "#0A6D9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2579 19.5815C55.1747 19.5815 58.3519 16.4043 58.3519 12.4876V8.34943H43.531L40.5543 11.8964H44.1619V12.4876C44.1619 16.4043 47.3391 19.5815 51.2579 19.5815Z",
    fill: "#0A6D9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3519 6.57591L59.7577 2.7135L40.4645 0L43.531 6.57591H58.3519Z",
    fill: "#0A6D9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0611 56.2379C8.0611 58.3142 9.74685 59.9979 11.8253 59.9979H32.2487C34.3251 59.9979 36.0108 58.3142 36.0108 56.2379V51.9368H8.0611V56.2379Z",
    fill: "#0A6D9A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76423 23.9892C1.68576 23.9892 0 25.6728 0 27.7534V48.1746C0 50.2531 1.68576 51.9368 3.76423 51.9368H8.06113V23.9892H3.76423Z",
    fill: "#0A6D9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4);
export default __webpack_public_path__ + "static/media/Group 4.081c5c7b78cdc1528341d0cf0e046fee.svg";
export { ForwardRef as ReactComponent };